/**
 * Formatting Utilities
 *
 * Coordinate and zoom level formatting for UI display.
 */

/**
 * Format coordinate for display (6 decimal places)
 */
export function formatCoordinate(value: number): string {
  if (Math.abs(value) < 0.000001 || Math.abs(value) > 1000000) {
    return value.toExponential(6);
  }
  return value.toFixed(6);
}

/**
 * Format zoom level for display
 */
export function formatZoom(zoom: number): string {
  if (zoom >= 1e9) {
    return zoom.toExponential(2);
  } else if (zoom >= 1000) {
    return zoom.toLocaleString(undefined, { maximumFractionDigits: 0 });
  }
  return zoom.toFixed(1);
}
